import type { z } from 'zod';
import type { StepSchema } from '../schemas';

type StepProps = z.infer<typeof StepSchema>;

export function isConditionMetInForm(
  formData: Record<string, unknown>,
  condition: { key: string; value: string },
): boolean {
  const valuesArr = condition.value.split('||');
  // need convert to String to make right check for boolean and numbers
  return valuesArr.some((v: string) => v === String(formData[condition.key]));
}

export function renderWhen(props: Pick<StepProps, 'renderWhen'>) {
  return (formData: Record<string, unknown>): boolean => {
    if (!props?.renderWhen?.length) {
      return true;
    }

    return props.renderWhen.every((condition) => {
      return isConditionMetInForm(formData, condition);
    });
  };
}
